import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';
const { setEnvPrefix } = ssCommonUtils;

export default class Image extends React.Component {
    constructor(props) { super(props); }

    componentDidMount() {
        const { url, id } = this.props;
        this.fetchImage(url, id);
    }

    fetchImage(url, id) {
        const imgElement = document.getElementById(this.createImageId(id));
        fetch(url, { credentials: 'include',
                     headers: { Authorization: `Bearer ${window.session.token}` }})
            .then(res => res.blob())
            .then(blob => imgElement.src = URL.createObjectURL(blob));
    }

    createImageId = id => `image-${id}`;

    handleImageLoadError(id) {
        let errorImg = document.getElementById(this.createImageId(id));
        errorImg.height = 100;
        errorImg.width = 100;
        errorImg.src = setEnvPrefix('/analyst/images/genericDoc.png');
    }

    render() {
        const { id } = this.props;
        return <img style = {{maxWidth: '100%'}} onError={() => this.handleImageLoadError(id)} id={this.createImageId(id)}/>;
    }
}
